import React from 'react';
import PropTypes from 'prop-types';
import './input.scss';

const ARRAY = [];
const Input = (props) => {
  const errors = Array.isArray(props.errors) ? props.errors : (props.errors ? [props.errors] : ARRAY);
  return (
    <React.Fragment>
      <div className={`${props.className}`}>
        {props.labelText && <label>{props.labelText}</label>}
        {
          props.isTextArea ? (
            <textarea type={props.type} name={props.name} placeholder={props.placeholder} value={props.value} disabled={props.disabled}
              onChange={props.onChange} className={errors.length ? 'input-error' : ''} /> 
          ) : (
            <input type={props.type} name={props.name} placeholder={props.placeholder} value={props.value} disabled={props.disabled}
              onChange={props.onChange} className={errors.length ? 'input-error' : ''} /> 
        )
      }
        {errors.length !==0 && (
          <div className="errors-hints">
            {errors.map((error) => (<span key={error}>{error}</span>))}
          </div>
        )}
      </div>

    </React.Fragment>
  );
}

Input.defaultProps = {
  type: 'text',
  className: '',
  isTextArea: false,
}

Input.propTypes = {
  isTextArea: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  errors: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default Input;


// WEBPACK FOOTER //
// ./src/components/Common/Input/index.js